import { useRouter } from 'next/router';
import React, { useEffect, useState } from 'react';
import { SVGBabyNames } from '../../../../Svg/BabyNamesPage';
import AnchorCoverTag from '../../../StoreHomePage/AnchorCoverTag';
import { clickedSectionEvent } from '../../instrumentation/instrumentation';
import SaveNameToast from '../../SearchResults/SearchResultCard/SaveNameToast';
import SearchNameSection from '../SearchNameSection';
import AlphabetsSection from './AlphabetsSection';
import {
  BrowseLetter,
  BrowseLetterTitle,
  ExploreNameTitle,
  MainTitle,
  TitleSemicircle,
  View,
  ViewSpan,
} from './styled';

export default function ExploreNames({ detailPage }) {
  const router = useRouter();
  const openSavedItemPage = (e) => {
    e.stopPropagation();
    e.preventDefault();
    setShowToast(true);
    setTimeout(
      function () {
        setShowToast(false);
      },
      [1000],
    );
    // }
  };
  const [showSaved, setshowSaved] = useState(false);
  const [showToast, setShowToast] = useState(false);
  useEffect(() => {
    if (JSON.parse(localStorage.getItem('savedData'))?.length > 0) {
      setshowSaved(true);
    }
  }, []);
  const clickedSaveItemHandler = (e) => {
    clickedSectionEvent(true, undefined, undefined, 'View My Saved Names');
    openSavedItemPage(e);
  };

  const deeplinkUrl = showSaved
    ? detailPage
      ? `/parenting/babynames/savedNames`
      : `${router.route}/savedNames`
    : '';
  return (
    <div>
      <MainTitle as={detailPage ? 'h2' : 'h1'}>
        Baby Names and Meaning
      </MainTitle>
      <AnchorCoverTag url={deeplinkUrl}>
        <View
          onClick={(e) => {
            if (!showSaved) {
              clickedSaveItemHandler(e);
            }
          }}
          showSaved={showSaved}
        >
          <SVGBabyNames id="save-filled" className="saved" />
          <ViewSpan>View My Saved Names</ViewSpan>
          <SVGBabyNames id="arrow" className="arrow" />
        </View>
      </AnchorCoverTag>

      <ExploreNameTitle>
        <TitleSemicircle></TitleSemicircle>
        <span className="titleName">Explore Beautiful Names</span>
      </ExploreNameTitle>
      <BrowseLetter>
        <BrowseLetterTitle>Browse by Letter</BrowseLetterTitle>
        <AlphabetsSection detailPage={detailPage} />
        <BrowseLetterTitle>Search by</BrowseLetterTitle>
        <SearchNameSection detailPage={detailPage} />
      </BrowseLetter>
      {showToast && <SaveNameToast />}
    </div>
  );
}
